var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.errorMsg)?_c('div',{staticClass:"error_block"},[_c('img',{staticClass:"icon_error",attrs:{"src":_vm.errorIconPass}}),_c('br'),_vm._v(" エラーが発生いたしました。"),_c('br'),_vm._v(" お手数ですが、エラー項目をご確認いただき、再度ご入力ください。 ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }